import { Button, useModal } from "@newsela/angelou";

import TrialModal from "@/components/TrialModal";
import withTrackEvent from "@/eventStream/withTrackEvent";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const ButtonWithTrackEvent = withTrackEvent(Button);

const eventProperties = {
  objectType: "Trial",
  actionPrefix: "Initiate",
  actionName: "Start",
  streamProperties: {
    description: "Start free trial modal overlay.",
  },
};

export const TrialButton = () => {
  const { data: user } = useUser();
  const { canStartPremiumTrial } = getUserProperties(user);

  const [baseTrialModalProps, setShouldShowTrialModal, returnFocusToRef] =
    useModal(false);

  // Do not show a start trial button when
  // the user is unable to able to start
  // a premium trial.
  if (!canStartPremiumTrial) return null;

  const showTrialModal = () => setShouldShowTrialModal(true);

  const hideTrialModal = () => setShouldShowTrialModal(false);

  const buttonProps = {
    onClick: showTrialModal,
    ref: returnFocusToRef,
    ...eventProperties,
  };

  const trialModalProps = {
    ...baseTrialModalProps,
    onBackgroundClick: hideTrialModal,
  };

  return (
    <>
      <ButtonWithTrackEvent {...buttonProps}>
        Start free trial
      </ButtonWithTrackEvent>
      <TrialModal {...trialModalProps} />
    </>
  );
};

export default TrialButton;
